export const LocaleEnum = Object.freeze({
    DE: 'de',
    EN: 'en',
    RO: 'ro',
});
